import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IBatchDetail } from '../../../models/batches';

type Props = {
    title: string;
    batches: IBatchDetail[];
};

export const Card: React.FC<Props> = ({ title, batches }) => {
    const navigate = useNavigate();

    const handleBatchClick = (batchId: number) => {
        navigate("/openBatches/" + batchId);
    }
    return (
        <div className="card">
            <h3>{title}</h3>
            <ul>
                {batches.map((batch, index) => (
                    <li key={index} onClick={() => handleBatchClick(batch.id)}>
                        {batch.uniqueIdentifier}
                    </li>
                ))}
            </ul>
        </div>
    );
};
